var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChilli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    width: 30,
    height: 30,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chilli",
    transform: "translate(0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mask",
    transform: "translate(-0.188 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 34.164, 25.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23745",
    "data-name": "Path 23745",
    d: "M6.346,0a2.333,2.333,0,0,1-.292.064A16.064,16.064,0,0,0,1.661.9,5.571,5.571,0,0,0,.28,1.7c-.442.345-.348.785.195.941a15.6,15.6,0,0,0,1.767.337,18.74,18.74,0,0,1,8.871,3.65,14.955,14.955,0,0,1,4.79,6.853c.495,1.4.876,2.836,1.341,4.245a10.744,10.744,0,0,0,1.532,3.1,13.68,13.68,0,0,0,1.005,1.087,6.693,6.693,0,0,1,.761-.085c.4,0,.8.036,1.194.057a3.928,3.928,0,0,0,1.826-2.543,10.033,10.033,0,0,0,.06-3.944A18.1,18.1,0,0,0,21.79,9.953a30.078,30.078,0,0,0-1.765-2.909,15.373,15.373,0,0,0-2.961-3.256,14.9,14.9,0,0,0-3.508-2.157A18.543,18.543,0,0,0,7.571.122C7.5.116,7.428.042,7.357,0ZM18.418,16.012a.42.42,0,0,1,.363-.489.472.472,0,0,1,.592.343c.067.21.107.428.169.638a10.6,10.6,0,0,0,1.4,2.992.507.507,0,0,1-.058.684.533.533,0,0,1-.686-.095,1.174,1.174,0,0,1-.114-.151,10.732,10.732,0,0,1-1.514-3.347C18.514,16.4,18.467,16.2,18.418,16.012Z",
    transform: "translate(3.089 0.003)",
    fill: "#fc5426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23746",
    "data-name": "Path 23746",
    d: "M0,0C.071.045.14.118.214.124A18.544,18.544,0,0,1,6.2,1.64,14.9,14.9,0,0,1,9.7,3.8a15.373,15.373,0,0,1,2.961,3.256,30.079,30.079,0,0,1,1.765,2.909,18.106,18.106,0,0,1,1.832,5.446,9.985,9.985,0,0,1-.06,3.944A3.918,3.918,0,0,1,14.375,21.9l1.71-.292c.453-.236.9-.492,1.363-.7a4.254,4.254,0,0,1,.777-.191,6.757,6.757,0,0,0,.738-4.252A19.74,19.74,0,0,0,14.353,5.883,15.186,15.186,0,0,0,5.919.653c-1.2-.29-2.443-.4-3.667-.592A.906.906,0,0,1,2.089,0Z",
    transform: "translate(10.449 0)",
    fill: "#ee4525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23747",
    "data-name": "Path 23747",
    d: "M1.281.2A11.851,11.851,0,0,1,1.43,3.558,9.036,9.036,0,0,1,.458,7c-.1.187-.206.368-.313.549-.212.358-.192.639.061.8.269.175.526.071.768-.306A9.444,9.444,0,0,0,2.293,4.549a13.485,13.485,0,0,0,0-4.367A1.429,1.429,0,0,0,2.242,0Z",
    transform: "translate(24.801 24.001)",
    fill: "#98da7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23748",
    "data-name": "Path 23748",
    d: "M1.443,3.489l.959-.2a4.429,4.429,0,0,0,2-2.115A.772.772,0,0,0,4.036,0a4.326,4.326,0,0,0-.777.192C2.794.4,2.349.657,1.9.893a.533.533,0,0,1-.022.154,4.53,4.53,0,0,1-1.7,2.038.894.894,0,0,0-.169.2Z",
    transform: "translate(24.639 20.708)",
    fill: "#81d161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23749",
    "data-name": "Path 23749",
    d: "M2.018,2.391a.9.9,0,0,1,.169-.2A4.531,4.531,0,0,0,3.892.154.533.533,0,0,0,3.914,0L2.2.292c-.4-.021-.8-.057-1.194-.057A6.692,6.692,0,0,0,.249.32c-.383.514-.332.94.214,1.269C.962,1.886,1.5,2.125,2.018,2.391Z",
    transform: "translate(22.619 21.602)",
    fill: "#97d97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23750",
    "data-name": "Path 23750",
    d: "M0,.508c.05.192.1.385.151.575A10.723,10.723,0,0,0,1.667,4.43a1.173,1.173,0,0,0,.114.151.525.525,0,0,0,.686.095.5.5,0,0,0,.058-.684A10.6,10.6,0,0,1,1.126,1C1.061.79,1.021.572.957.362A.472.472,0,0,0,.365.019.422.422,0,0,0,0,.508Z",
    transform: "translate(21.505 15.505)",
    fill: "#d73d24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilli);
export default __webpack_public_path__ + "static/media/chilli.9ee6ebd9b3d5fd110a79aeb10bb22e61.svg";
export { ForwardRef as ReactComponent };